<template>
	<div class="solution_div clearfix">
		<div class="left">
			<div class="solution_table">
				<div class="table_title">孩子</div>
				<table cellspacing="0" class="table_product">
					<thead>
						<th style=""></th>
						<th style="">基本保额</th>
						<th style="">线下代理人保费</th>
						<th style="">骆驼规划保费</th>
					</thead>
					<tbody>
						<tr>
							<td class="gray">
								重疾险
							</td>
							<td>50万</td>
							<td>9008.12元</td>
							<td>635元</td>
						</tr>
						<tr>
							<td class="gray">
								百万医疗
							</td>
							<td>200万</td>
							<td>854元</td>
							<td>556元</td>
						</tr>
						<tr>
							<td class="gray">
								意外险
							</td>
							<td>20万</td>
							<td>740元</td>
							<td>56元</td>
						</tr>
						<tr class="power">
							<td>
								总计
							</td>
							<td>270万</td>
							<td>10602.12元</td>
							<td class="orange fz20">1247元</td>
						</tr>
					</tbody>
				</table>
				<div class="table_footer">
					<span>节省保费</span> <span class="num">88</span
					><span class="percent">%</span>
				</div>
			</div>
			<div class="solution_table mt_table">
				<div class="table_title">成人</div>
				<table cellspacing="0" class="table_product">
					<thead>
						<th style=""></th>
						<th style="">基本保额</th>
						<th style="">线下代理人保费</th>
						<th style="">骆驼规划保费</th>
					</thead>
					<tbody>
						<tr>
							<td class="gray">
								重疾险
							</td>
							<td>50万</td>
							<td>17623.84元</td>
							<td>5515元</td>
						</tr>
						<tr>
							<td class="gray">
								百万医疗
							</td>
							<td>200万</td>
							<td>232元</td>
							<td>232元</td>
						</tr>
						<tr>
							<td class="gray">
								意外险
							</td>
							<td>30万</td>
							<td>760元</td>
							<td>98元</td>
						</tr>
						<tr>
							<td class="gray">
								寿险
							</td>
							<td>50万</td>
							<td>1565元</td>
							<td>534元</td>
						</tr>
						<tr class="power">
							<td>
								总计
							</td>
							<td>330万</td>
							<td>20180.84元</td>
							<td class="orange fz20">6379元</td>
						</tr>
					</tbody>
				</table>
				<div class="table_footer">
					<span>节省保费</span> <span class="num">68</span
					><span class="percent">%</span>
				</div>
			</div>
		</div>
		<div class="right">
			<div class="solution_table">
				<div class="table_title">家庭</div>
				<table cellspacing="0" class="table_product">
					<thead>
						<th style=""></th>
						<th style=""></th>
						<th style="">基本保额</th>
						<th style="">线下代理人保费</th>
						<th style="">骆驼规划保费</th>
					</thead>
					<tbody>
						<tr>
							<td rowspan="5">先生</td>
							<td class="gray">
								重疾险
							</td>
							<td>50万</td>
							<td>17623.84元</td>
							<td>5515元</td>
						</tr>
						<tr>
							<td class="gray">
								百万医疗
							</td>
							<td>200万</td>
							<td>232元</td>
							<td>232元</td>
						</tr>
						<tr>
							<td class="gray">
								意外险
							</td>
							<td>30万</td>
							<td>760元</td>
							<td>98元</td>
						</tr>
						<tr>
							<td class="gray">
								寿险
							</td>
							<td>50万</td>
							<td>1565元</td>
							<td>534元</td>
						</tr>
						<tr>
							<td class="gray">
								合计
							</td>
							<td>330万</td>
							<td>20180.84元</td>
							<td>6379元</td>
						</tr>
						<tr></tr>
						<tr class="border_top_split">
							<td rowspan="5">太太</td>
							<td class="gray">
								重疾险
							</td>
							<td>50万</td>
							<td>16918.22元</td>
							<td>5170元</td>
						</tr>
						<tr>
							<td class="gray">
								百万医疗
							</td>
							<td>200万</td>
							<td>232元</td>
							<td>232元</td>
						</tr>
						<tr>
							<td class="gray">
								意外险
							</td>
							<td>30万</td>
							<td>760元</td>
							<td>98元</td>
						</tr>
						<tr>
							<td class="gray">
								寿险
							</td>
							<td>50万</td>
							<td>760元</td>
							<td>287.5元</td>
						</tr>
						<tr>
							<td class="gray">
								合计
							</td>
							<td>330万</td>
							<td>18670.22元</td>
							<td>5787.5元</td>
						</tr>
						<tr></tr>
						<tr class="border_top_split">
							<td rowspan="4">孩子</td>
							<td class="gray">
								重疾险
							</td>
							<td>50万</td>
							<td>9008.12元</td>
							<td>635元</td>
						</tr>
						<tr>
							<td class="gray">
								百万医疗
							</td>
							<td>200万</td>
							<td>854元</td>
							<td>556元</td>
						</tr>
						<tr>
							<td class="gray">
								意外险
							</td>
							<td>20万</td>
							<td>740元</td>
							<td>56元</td>
						</tr>
						<tr>
							<td class="gray">
								合计
							</td>
							<td>270万</td>
							<td>10602.12元</td>
							<td>1247元</td>
						</tr>
						<tr class="power">
							<td></td>
							<td>
								总计
							</td>
							<td>930万</td>
							<td>49453.18元</td>
							<td class="orange fz20">13413.5元</td>
						</tr>
					</tbody>
				</table>
				<div class="table_footer">
					<span>节省保费</span> <span class="num">73</span
					><span class="percent">%</span>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'SolutionTable',
	data() {
		return {};
	},
	methods: {}
};
</script>
<style lang="scss" scoped>
.solution_div {
	.solution_table {
		&.mt_table {
			margin-top: 112px;
		}
		width: 568px;
		border-bottom: 2px solid #feb008;
		.table_title {
			background: url('~@/assets/images/version/plan_title.png') no-repeat;
			background-size: 568px 60px;
			font-size: 24px;
			font-family: PingFangHK-Medium, PingFangHK;
			font-weight: 500;
			color: rgba(255, 255, 255, 1);
			line-height: 60px;
			height: 60px;
			text-indent: 29px;
		}
		.table_product {
			width: 100%;
			text-align: center;
			font-size: 14px;
			font-family: PingFangSC-Medium, PingFang SC;
			font-weight: 500;
			color: #3b3b58;
			td,
			th {
				height: 50px;
			}
			thead,
			tr:nth-child(even) {
				background: #f9f7f2;
			}
			thead,
			td.gray {
				color: #999;
			}
			td.orange {
				color: #ff9800;
			}
			td.fz20 {
				font-size: 20px !important;
			}
			tr.border_top_split {
				td {
					border-top: 1px solid rgba(108, 111, 144, 0.5);
				}
			}
			tr.power {
				td {
					font-size: 16px;
					font-family: PingFangSC-Semibold, PingFang SC;
					font-weight: 600;
				}
			}
		}
		.table_footer {
			height: 75px;
			text-align: right;
			font-size: 20px;
			font-family: PingFangSC-Semibold, PingFang SC;
			font-weight: 600;
			color: #3b3b58;
			line-height: 75px;
			vertical-align: middle;
			span {
				vertical-align: middle;
			}
			span.num {
				margin-left: 14px;
				font-size: 37px;
				font-family: SourceHanSansCN-Medium, SourceHanSansCN;
				font-weight: 500;
				color: #ff9800;
			}
			span.percent {
				font-size: 30px;
				font-family: SourceHanSansCN-Bold, SourceHanSansCN;
				font-weight: bold;
				color: #ff9800;
				margin-right: 17px;
			}
		}
	}
	.left {
		float: left;
	}
	.right {
		float: right;
	}
}
</style>
